import React, { memo, useState } from "react";
import { Logo } from '../Logo';
import { Menutoggle } from "../MenuToggle";
import { SideDrawer } from "../SideDrawer";

export const Header = memo(() => {
  const [toggleSideDrawer, setToggleSideDrawer] = useState(false);
  return (
    <header className="header" >
      <div className="flex flex-between fullsize container header-container">
        <Logo />
        <Menutoggle setToggleSideDrawer={setToggleSideDrawer} />
        <SideDrawer toggleSideDrawer={toggleSideDrawer} />
      </div>
    </header>
  );
});
